import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'react-i18next'

const MONTH_NAMES_PL = [
	'styczeń',
	'luty',
	'marzec',
	'kwiecień',
	'maj',
	'czerwiec',
	'lipiec',
	'sierpień',
	'wrzesień',
	'październik',
	'listopad',
	'grudzień',
]

export default function MonthSelector({
	year,
	month,
	onPrev,
	onNext,
	onYearChange,
	onMonthChange,
}) {
	const { t } = useTranslation()
	const label = `${MONTH_NAMES_PL[month - 1] || ''} ${year}`

	const years = []
	const currentYear = new Date().getFullYear()
	for (let y = currentYear - 3; y <= currentYear + 2; y += 1) years.push(y)

	return (
		<div className="flex flex-wrap items-center justify-between gap-3 rounded-lg border border-gray-200 bg-white px-4 py-3 shadow-sm">
			<button
				type="button"
				onClick={onPrev}
				className="inline-flex items-center gap-1 rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
			>
				<ChevronLeftIcon className="h-4 w-4" />
				{t('rozliczenia.details.prevMonth')}
			</button>

			<div className="flex flex-wrap items-center gap-2">
				<span className="text-base font-semibold capitalize text-gray-900">{label}</span>
				<select
					value={month}
					onChange={event => onMonthChange(Number(event.target.value))}
					className="rounded-md border border-gray-300 bg-white px-2 py-1.5 text-sm text-gray-900"
				>
					{MONTH_NAMES_PL.map((name, index) => (
						<option key={name} value={index + 1}>
							{name}
						</option>
					))}
				</select>
				<select
					value={year}
					onChange={event => onYearChange(Number(event.target.value))}
					className="rounded-md border border-gray-300 bg-white px-2 py-1.5 text-sm text-gray-900"
				>
					{years.map(item => (
						<option key={item} value={item}>{item}</option>
					))}
				</select>
			</div>

			<button
				type="button"
				onClick={onNext}
				className="inline-flex items-center gap-1 rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
			>
				{t('rozliczenia.details.nextMonth')}
				<ChevronRightIcon className="h-4 w-4" />
			</button>
		</div>
	)
}
